import { render, staticRenderFns } from "./PhysicalPersonCreate.vue?vue&type=template&id=3be810b2&scoped=true"
import script from "./PhysicalPersonCreate.vue?vue&type=script&lang=js"
export * from "./PhysicalPersonCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be810b2",
  null
  
)

export default component.exports